import { Image } from "@/components/Image";
import { Icon, IconName } from "@/components/icons/Icon";

export interface ImageContainerProps {
    image: File | string | null;
    size: number;
    alt: string;
    containerClassName?: string;
    placeholderIconName?: IconName;
    priority?: boolean;
    onClick?: () => void;
}

export default function ImageContainer({
    image,
    alt,
    containerClassName,
    placeholderIconName,
    size,
    priority = false,
    onClick,
}: ImageContainerProps) {
    return (
        <div
            className={`image-container ${containerClassName} ${
                !image ? "placeholder" : ""
            } ${onClick ? "cursor-pointer" : ""}`}
            style={{
                width: size,
                height: size,
                minWidth: size,
                minHeight: size,
            }}
            onClick={onClick}
        >
            {image ? (
                <Image
                    src={image}
                    alt={alt}
                    width={size}
                    height={size}
                    priority={priority}
                />
            ) : placeholderIconName ? (
                <Icon
                    name={placeholderIconName}
                    width={size / 2}
                    height={size / 2}
                />
            ) : (
                <></>
            )}
        </div>
    );
}
